import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider, observer } from 'mobx-react'
import Routes from './Routes'
import './index.css'
import validator from 'validatorjs'
import { stores } from './store'
import t from './service/translate.service'
import { interceptor } from './service/api.service'
// require('./polyfill.js')
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './azureB2C/authConfig'
import { ThemeProvider } from './providers/ThemeProvider'
import datadogService from './service/datadog.service'

const msalInstance = new PublicClientApplication(msalConfig)

validator.useLang(t.locale)
interceptor()
const root = createRoot(document.getElementById('root'))
const UserLoading = observer(() => {
  return (
    <ThemeProvider>
      <Provider {...stores}>
        {/*<Router history={history} routes={Routes} />*/}
        <Routes />
      </Provider>
    </ThemeProvider>
  )
})
root.render(
  <MsalProvider instance={msalInstance}>
    <UserLoading/>
  </MsalProvider>
)

 validator.register(
   'contract',
   value => {
     return value.match(
       /^[A-Z]{1,2}\d{2,4}_[A-Z]_[A-Z]{0,2}\d{1,5}\.[A-Z]{0,2}\d{2,3}$/
     )
   },
   t.INVALID_CONTRACT_FORMAT
 )

 validator.register(
   'phone',
   value => {
     // eslint-disable-next-line
     return value.match(/[\+0](\s*[\(\)0-9+-]+)+/)
   },
   t.PHONE_FORMAT
 )

const cookieConsent = localStorage.getItem('cookiefirst-consent')
const consent = JSON.parse(cookieConsent || "{}")
if ((consent.performance && process.env.REACT_APP_ENV === 'production')  || process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'uat') {
  datadogService.rum.init()
}
